import type { CrmPatientDetail, PatientHistoryCollection, PatientHistoryQuery } from "./api";

export function nextPatientHistoryQuery(
  detail: CrmPatientDetail,
  kind: PatientHistoryCollection,
): PatientHistoryQuery | null {
  const page = detail.pagination?.[kind];
  return page?.hasMore ? { [`${kind}Offset`]: page.offset + page.limit, limit: page.limit } : null;
}

/** Merge one independently paged collection; never overwrite unrelated medical sections. */
export function mergePatientHistory(
  current: CrmPatientDetail,
  next: CrmPatientDetail,
  kind: PatientHistoryCollection,
): CrmPatientDetail {
  if (current.patient.id !== next.patient.id || current.access.id !== next.access.id)
    return current;
  const previousPage = current.pagination?.[kind];
  const nextPage = next.pagination?.[kind];
  if (!current.pagination || !nextPage || !previousPage || nextPage.offset < previousPage.offset)
    return current;
  return {
    ...current,
    [kind]: [
      ...current[kind],
      ...next[kind].filter((item) => !current[kind].some((old) => old.id === item.id)),
    ],
    pagination: { ...current.pagination, [kind]: nextPage },
  };
}
